import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type ClientAgencyCodesTreeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ClientAgencyCodesTreeQuery = { __typename?: 'Query', sourceCodes: { __typename?: 'SourceCodes', clientAgencyCodes: Array<{ __typename?: 'AgencyCodeCategory', key: string, title: string, children: Array<{ __typename?: 'AgencyCode', key: string, title: string }> }> } };


export const ClientAgencyCodesTreeDocument = gql`
    query ClientAgencyCodesTree {
  sourceCodes {
    clientAgencyCodes {
      key: id
      title: name
      children: codes {
        key: id
        title: name
      }
    }
  }
}
    `;

/**
 * __useClientAgencyCodesTreeQuery__
 *
 * To run a query within a React component, call `useClientAgencyCodesTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientAgencyCodesTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientAgencyCodesTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientAgencyCodesTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>(ClientAgencyCodesTreeDocument, options);
      }
export function useClientAgencyCodesTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>(ClientAgencyCodesTreeDocument, options);
        }
// @ts-ignore
export function useClientAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>;
export function useClientAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClientAgencyCodesTreeQuery | undefined, ClientAgencyCodesTreeQueryVariables>;
export function useClientAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>(ClientAgencyCodesTreeDocument, options);
        }
export type ClientAgencyCodesTreeQueryHookResult = ReturnType<typeof useClientAgencyCodesTreeQuery>;
export type ClientAgencyCodesTreeLazyQueryHookResult = ReturnType<typeof useClientAgencyCodesTreeLazyQuery>;
export type ClientAgencyCodesTreeSuspenseQueryHookResult = ReturnType<typeof useClientAgencyCodesTreeSuspenseQuery>;
export type ClientAgencyCodesTreeQueryResult = Apollo.QueryResult<ClientAgencyCodesTreeQuery, ClientAgencyCodesTreeQueryVariables>;